import React from 'react';
import { Box, Chip, Divider, Tooltip, Typography } from '@mui/material';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import { Card } from '@mui/material';
import { STATUS_COLOR, STATUS_LABEL } from './weekendUtils';
import '../../components/LeaveStatusCard/LeaveStatusCard.css';

const ellipsis = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/** Same header layout as the Remote Office Hours / leave cards: title, date, chips. */
export const WeekendCard = ({
  title,
  subtitle,
  dateText,
  chips = [],
  status,
  actions,
  children,
}) => (
  <Card variant="outlined" sx={{ mb: 2 }}>
    <div className="leave-status-container pb-0">
      <div className="space-between-container">
        <Tooltip title={title || ''} arrow>
          <Typography
            sx={{ width: '30%', minWidth: 0, ...ellipsis }}
            variant="h6"
          >
            {title}
          </Typography>
        </Tooltip>
        <Typography sx={{ width: '38%', textAlign: 'center' }}>
          <CalendarMonthRoundedIcon fontSize="small" className="mr-1 mt-n1" />
          {dateText}
        </Typography>
        <Box sx={{ width: '32%', textAlign: 'right' }}>
          {chips.map((chip) => (
            <Chip
              key={chip}
              label={chip}
              color="secondary"
              size="small"
              variant="outlined"
              sx={{ marginRight: 1.5 }}
            />
          ))}
          {status && (
            <Chip
              label={STATUS_LABEL[status] || status}
              color={STATUS_COLOR[status]}
              size="small"
              variant="outlined"
            />
          )}
        </Box>
      </div>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {subtitle}
        </Typography>
      )}
      {actions && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
            mt: 2,
            mb: 1,
          }}
        >
          {actions}
        </Box>
      )}
      {children && (
        <>
          <Divider sx={{ my: 1.5 }} />
          <Box sx={{ pb: 1.5 }}>{children}</Box>
        </>
      )}
    </div>
  </Card>
);

/** Blue label + value pair, as used in the expanded part of the other cards. */
export const LabelledText = ({ label, children }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="body1" color="#4D6CD9" sx={{ mb: 0.5 }}>
      <strong>{label}:</strong>
    </Typography>
    <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
      {children}
    </Typography>
  </Box>
);

export default WeekendCard;
